import { Directive, HostListener, Input, forwardRef } from "@angular/core";
import { AbstractControl, ControlValueAccessor, DefaultValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from "@angular/forms";
import { CpfValidator } from "../validators/cpf.validator";
import { CnpjValidator } from "../validators/cnpj.validator";

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[cpfCnpjMask]',
    standalone: false,
    providers: [{
      provide: NG_VALIDATORS, useExisting: CpfCnpjDirective, multi: true
    }]
  })
  export class CpfCnpjDirective implements Validator {
    onTouched: any;
    onChange: any;
    value: '' | undefined;
    cpfType = '999.999.999-99';
    cnpjType = '99.999.999/9999-99';
    @Input('cpfMask') cpfMask: string | undefined;
    @Input('cnpjMask') cnpjMask: string | undefined;
  
    constructor() { }
  
    validate(control: AbstractControl): { [key: string]: any } | null{
      if(control.value) {
        const controlCPFAux = this.cpfType.replace(/\D/g, '');
        const controlAux = control.value.replace(/\D/g, '');
  
        if (controlAux.length <= controlCPFAux.length)
            return CpfValidator.validate(control)!;
        else
            return CnpjValidator.validate(control);
      }
        return null;
    }
  
    @HostListener('input', ['$event'])
    onInput($event: any) {
      if ($event.inputType && $event.inputType.includes("deleteContent")) {
        return;
      }
      const value = $event.target.value.replace(/\D/g, '');
      if (value.length <= 11) {
        $event.target.value = this.mascaraCpf(value);
      } else if (value.length <= 18) {
        $event.target.value = this.mascaraCnpj(value);
      }
    }
  
    mascaraCpf(value: string): string {
      const replacement = this.cpfType.replace(/\D/g, '').replace(/9/g, '_');
      const valueMask = value + replacement.substring(0, replacement.length - value.length);
      let valueMaskPos = 0;
  
      value = '';
      for (let i = 0; i < this.cpfType.length; i++) {
        if (isNaN(parseInt(this.cpfType.charAt(i)))) {
          value += this.cpfType.charAt(i);
        } else {
          value += valueMask[valueMaskPos++];
        }
      }
  
      if (value.indexOf('_') > -1) {
        value = value.substr(0, value.indexOf('_'));
      }
  
      return value;
    }
  
    mascaraCnpj(value: string): string {
  
      const replacement = this.cnpjType.replace(/\D/g, '').replace(/9/g, '_');
      const valueMask = value + replacement.substring(0, replacement.length - value.length);
      let valueMaskPos = 0;
  
      value = '';
      for (let i = 0; i < this.cnpjType.length; i++) {
        if (isNaN(parseInt(this.cnpjType.charAt(i)))) {
          value += this.cnpjType.charAt(i);
        } else {
          value += valueMask[valueMaskPos++];
        }
      }
      if (value.indexOf('_') > -1) {
        value = value.substr(0, value.indexOf('_'));
      }
  
      return value;
    }
  }